import React from "react";
import { Link } from "react-router-dom";
import logo from "../logo.png";

const buttonStyle = {
  width: "100%",
  padding: "16px 0",
  fontSize: 20,
  border: "none",
  transition: "background 0.2s, color 0.2s",
  cursor: "pointer",
  background: "#f3f4f6",
    color: "#222",
};

const buttonHoverStyle = {
  background: "#e0e7ef",
  color: "#111",
};

const signupStyle = {
  ...buttonStyle,
  background: "#769ae8ff",
  color: "#fff",
};

const signupHoverStyle = {
  background: "#4675e5ff",
  color: "#fff",
};

const Home = () => {
  const [signupHover, setSignupHover] = React.useState(false);
  const [loginHover, setLoginHover] = React.useState(false);

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 32,
          marginBottom: 32,
        }}
      >
        <img
          src={logo}
          alt="Counselor Notes Logo"
          style={{ width: 400, maxWidth: "90vw" }}
        />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
        }}
      >
        <h1 style={{ textAlign: "center" }}>Welcome</h1>
        <div
          style={{
            marginTop: 32,
            display: "flex",
            flexDirection: "column",
            gap: 24,
            width: 320,
          }}
        >
          <Link to="/login" style={{ width: "100%" }}>
            <button
              style={
                loginHover
                  ? { ...buttonStyle, ...buttonHoverStyle }
                  : buttonStyle
              }
              onMouseEnter={() => setLoginHover(true)}
              onMouseLeave={() => setLoginHover(false)}
            >
              Login
            </button>
          </Link>
          <Link to="/signup" style={{ width: "100%" }}>
            <button
              style={
                signupHover
                  ? { ...signupStyle, ...signupHoverStyle }
                  : signupStyle
              }
              onMouseEnter={() => setSignupHover(true)}
              onMouseLeave={() => setSignupHover(false)}
            >
              Sign Up
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
